export default {
      id: "ic_responsible_gambling-usage",
      viewBox: "0 0 15 16",
      url: "/" + "images/icons.3.109.2.svg#ic_responsible_gambling-usage",
      toString: function () {
        return this.url;
      }
    }